export default {
    init() {
        (function () {
            var protocol = window.location.protocol + '//',
                host = window.location.host,
                pathname = window.location.pathname,
                // turn into an array
                patharr = pathname.split("/"),
                // grab the first part e.g. about
                pathFirstPart = '/' + patharr[1] + '/' + patharr[2] + '/',
                // url to push
                pageUrl = protocol + host + pathFirstPart,
                // patharrLen = patharr.length,
                // grab the last part
                teammember = patharr[patharr.length - 1]
            // url suffix
            //filterContainer = $('#team-member-filter')
            ;

            // opening and closing modals
            $(document)
                .on('show.bs.modal', '.modal', function () {
                    var _self = $(this),
                        urlSuffix = _self.data('url-suffix'),
                        newUrl = pageUrl + urlSuffix;

                    window.history.pushState({
                        path: newUrl,
                    }, '', newUrl);
                })
                .on('hidden.bs.modal', '.modal', function () {
                    window.history.pushState({
                        path: pageUrl,
                    }, '', pageUrl);
                })
                .ready(function () {
                    // show the modal if url is correct
                    if (isTeamMemberUrl(patharr)) {
                        var teamMemberModal = $('#' + teammember),
                            teamMemberButton = $('button[data-target="#' + teammember + '"]'),
                            teamMemberButtonPos = teamMemberButton[0].getBoundingClientRect();

                        $(window).scrollTop(teamMemberButtonPos.top);

                        // and show the modal
                        teamMemberModal.modal('show');
                    }
                })

            function isTeamMemberUrl(patharr) {
                var patharrLen = patharr.length;

                // check if the path array contains team-member
                var i = 0;
                for (i; i < patharrLen; i++) {
                    if (patharr[i] == 'board-member') {
                        return true;
                    }
                }

                return false;
            }
        }())
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/meetTheBoard.js